import Card from "../../../components/Card";
import DropIcon from "../../../assets/Icons/dropdownIcon.svg";
import ChatIcon from "../../../assets/Icons/ChatIcon";
import { Link } from "react-router-dom";
import { EMIText, LoanStatusText, LoanTenureText } from "../../Home/component/RecomendedLoanSection";
import { useState } from "react";
import DropdownTexts from "./DropdownTexts";
import { Button } from "../../../components/Buttons";
const InProcessLoanCard = ({ loanType, totalAmount, interest, tenure, statusColor, value, loanDate, type }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  return (<div className="flex">
    <Card className="py-[18px] px-[18px] min-w-full md:min-w-[480px] flex flex-col justify-between" >
      <div className="flex justify-between">
        <div className="">
          <div className="flex gap-[12px] cursor-pointer" onClick={toggleDropdown}>
            <p className="font-Apparat font-[700] text-[16px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%]">{loanType}</p>
            <img src={DropIcon} />
          </div>
        </div>
        <div className="flex justify-end">
          <Link class="text-primary font-Apparat font-[700] text-[18px] leading-[30px] tracking-[-2%] hidden md:flex items-center gap-[4px]">
            <ChatIcon />
            <span>Support</span>
          </Link>
          <div className="flex md:hidden">
            <LoanStatusText title="" statusClass={statusColor} status={value} />
          </div>
        </div>
      </div>
      {!dropdownOpen && <div className="grid grid-cols-4 mt-[12px] gap-[4px] col-end">
        <div className="col-span-1">
          <LoanTenureText title="Total Amount" value={`₹ ${totalAmount}`} />
        </div>
        <div className="col-span-1  text-start">
          <div>
            <LoanTenureText title="interest" value={`${interest}`} />
          </div>
        </div>
        <div className="col-span-1 md:col-span-2 text-start">
          <div>
            <LoanTenureText title="tenure" value={`${tenure}`} />
          </div>
        </div>
        <div className="col-span-1 flex md:hidden text-start">
          <div>
            <LoanTenureText title="EMI" value={`Rs. 20000`} />
          </div>
        </div>
      </div>}
      {dropdownOpen && <div className="flex flex-col gap-[12px] mt-[24px]">
        <DropdownTexts
          label={"applied on"}
          value={loanDate}
        />
        <DropdownTexts
          label={"Loan ID"}
          value={"----"}
        />
        <DropdownTexts
          label={"AMOUNT"}
          value={"----"}
        />
        <DropdownTexts
          label={"RATE"}
          value={"----"}
        />
        <DropdownTexts
          label={"EMI"}
          value={"----"}
        />
        <DropdownTexts
          label={"Tenure"}
          value={"6 Months"}
        />
        {
          type === "Approved" &&
          <div className="flex flex-col gap-[10px]">
            <div className="flex justify-center gap-[4px]">
              <p className="font-Apparat font-[500] text-[12px] leading-[12px] tracking-[-2%] text-[#424952]">PAY NEXT EMI</p>
              <p className="font-Apparat font-[700] text-[12px] leading-[12px] tracking-[-2%] text-[#00C08B]">DUE IN 7 DAYS</p>
            </div>
            <Button title={"Sign Loan Agreement"} className="w-full flex justify-center" />
          </div>
        }
      </div>}
      {dropdownOpen && <Link class="text-primary font-Apparat font-[500] text-[10px] leading-[30px] tracking-[-2%] flex md:hidden justify-center gap-[4px] mt-[8px]">
        <ChatIcon />
        <span>Support</span>
      </Link>}
    </Card>
    <Card className="hidden md:flex flex-col justify-between border-dashed border-2 lg:px-[10px] lg:w-[220px] xl:w-[340px] h-[164px]">
      <div className="grid grid-cols-2">
        <div className="grid-span-1">
          <EMIText title="EMI" value={`---`} />
        </div>
        <div className="grid-span-1 text-end">
          <EMIText title="EMI Paid" value={`---`} />
        </div>
      </div>
      <div className="grid grid-cols-2 items-end">
        <LoanStatusText title="" statusClass={statusColor} status={value} />
      </div>

    </Card>
  </div>)
}
export default InProcessLoanCard;